<template>
  <v-container >
    <v-row>
      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการข้อมูลการศึกษา</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + user_edus.length }} รายการ) </span>
            <v-spacer></v-spacer>

          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="user_edus"
                sort-by="order_seq">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>


              <template v-slot:item.edu_code="{ item }">
                <span>{{ displayText(item.edu_code) }}</span>

              </template>
              <template v-slot:item.order_seq="{ item }">
                <span>{{ displayOrder(item.edu_code) }}</span>

              </template>

              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="6" >


                  <v-select
                      v-model="editForm.edu_code"
                      :items="education_combo"
                      item-text="edu_name_th"
                      item-value="edu_code"
                      label="รหัสระดับการศึกษา"

                  ></v-select>

                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.edu_year"
                      :counter="4"
                      :rules="editForm.textReqRules.concat(editForm.numRules)"
                      label="ปี ที่สำเร็จการศึกษา พ.ศ. (TH)"
                      required
                  ></v-text-field>
                </v-col>


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.edu_degree_th"
                      :rules="editForm.textReqRules"
                      label="วุฒิการศึกษา (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.edu_degree_en"
                      :rules="editForm.textReqRules"
                      label="วุฒิการศึกษา (EN)"
                      required
                  ></v-text-field>
                </v-col>


              </v-row>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.edu_degree_place_th"
                      :rules="editForm.textReqRules"
                      label="สถานศึกษา (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.edu_degree_place_en"
                      :rules="editForm.textReqRules"
                      label="สถานศึกษา (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>


              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.remark"
                      label="หมายเหตุ/เกียรตินิยมอันดับ/อื่นๆ (TH/EN)"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import axios from "axios";

export default {
  name: 'EduLevelManagement',
  data() {
    return {
      state: 'index',
      snackbar: null,
      search: '',
      selected: [],
      headers: [
        {
          text: 'ปี(พ.ศ.)',
          align: 'start',
          value: 'edu_year',
        },
        {text: 'ระดับการศึกษา', value: 'edu_code'},
        {text: 'ลำดับ', value: 'order_seq'},
        {text: 'วุฒิการศึกษา', value: 'edu_degree_th'},
        {text: 'สถานศึกษา', value: 'edu_degree_place_th'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ['order_seq','edu_year'],
        sortDesc: [true,true]
      },

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        edu_code: '',
        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
        numRules: validateRules.numRules,
        edu_degree_th: '',
        edu_degree_en: '',
        edu_degree_place_th: '',
        edu_degree_place_en: '',
        remark: '',
        active: 'N',
      },
      education_combo:{}
    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('user_edus', ['user_name','user_edus', "isReceiving", "isDeleting", "idToDelete", "user_eduMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },

  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    user_eduMessage() {

      if (this.user_eduMessage !== '') {
        this.notification = this.user_eduMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getUser_edusRequest(this.user_name);
    this.getCombobox('dceducationsActive');

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('user_edus',
        [
          "getUser_edusRequest",
          "deleteUser_eduRequest",
          "updateUser_eduRequest",
          "createUser_eduRequest"
        ]
    ),
    async getCombobox(combo_name) {

      try {

        await axios.post(config.baseURLApi + '/combo/' + combo_name, '', {
          headers: {},
        }).then(res => {
          this.education_combo = res.data;
        });


      } catch (e) {
        this.showSnackbar(e);
      }
    },

    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.editForm.edu_id = null;
      this.editForm.edu_code = null;
      this.editForm.edu_year = null;
      this.editForm.user_name = this.user_name.user_name;
      this.editForm.edu_degree_th = null;
      this.editForm.edu_degree_en = null;
      this.editForm.edu_degree_place_th = null;
      this.editForm.edu_degree_place_en = null;
      this.editForm.remark = '-';
      this.editForm.active = 'Y';
      this.state = 'addForm';

    },
    editItem(item) {
      this.editedIndex = this.user_edus.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.edu_id = item.edu_id;
      this.editForm.edu_code = item.edu_code;
      this.editForm.user_name = item.user_name;
      this.editForm.edu_year = item.edu_year;
      this.editForm.edu_degree_th = item.edu_degree_th;
      this.editForm.edu_degree_en = item.edu_degree_en;
      this.editForm.edu_degree_place_th = item.edu_degree_place_th;
      this.editForm.edu_degree_place_en = item.edu_degree_place_en;
      this.editForm.remark = item.remark;
      this.editForm.active = item.active;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteUser_eduRequest({edu_id: item.edu_id})


    },
    close() {

      if (this.errorMessage == false || this.user_eduMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.user_edus[this.editedIndex], this.editForm)
            :
            this.updateUser_eduRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.user_edus.push(this.editForm)
            :
            this.createUser_eduRequest(this.editForm)
      }

    },

    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },

    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },

    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    displayText(item) {
      return !this.education_combo.length==true?'':(this.education_combo.find(combobox => combobox.edu_code === item)).edu_name_th;

    },
    displayOrder(item) {
      return !this.education_combo.length==true?'':(this.education_combo.find(combobox => combobox.edu_code === item)).order_seq*1;

    },

  },
}
</script>

<style src="./UserEduManagement.scss" lang="scss"/>
